<template>
  <van-popup
    v-model="openBox"
    class="popup"
    round
    position="bottom"
    :safe-area-inset-bottom="true"
    @click-overlay="close"
  >
    <!-- <div class="top fixwh">
      <div class="close" @click="close">取消</div>
      <div class="title">选择单位</div>
    </div> -->
    <!-- @confirm="onConfirm"
      @cancel="onCancel"
      @change="onChange" -->
    <van-picker
      title="选择单位"
      show-toolbar
      value-key="unitName"
      :columns="opts"
      @cancel="close"
      @confirm="onConfirm"
    />
  </van-popup>
</template>

<script>
export default {
  name: 'UnitsPop',
  props: {
    opts: {
      type: Array,
      default: () => []
    },
    open: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      openBox: false
    }
  },
  watch: {
    open: {
      handler(val) {
        this.openBox = val
      },
      immediate: true
    }
  },
  methods: {
    onConfirm(value) {
      console.log('xxxx', value)
      this.$emit('update:unit', value)
      this.close()
    },
    close() {
      this.$emit('update:open', false)
    }
  }
}
</script>

<style lang="less" scoped>
.popup {
  // height: 60%;
  display: flex;
  flex-direction: column;
  .desc {
    flex-grow: 1;
  }
}
.top {
  display: flex;
  height: 88px;
  justify-content: center;
  align-items: center;
  position: relative;
}
.title {
  font-family: PingFangSC-Medium;
  font-size: 34px;
  color: #333333;
  text-align: center;
  font-weight: 500;
}
.close {
  position: absolute;
  left: 30px;
  font-family: PingFangSC-Medium;
  font-size: 34px;
  color: #333333;
  font-weight: 500;
  top: 20px;
  height: 48px;
  line-height: 48px;
}
</style>
